/**
 * StepPalette — Sidebar showing available step types.
 * Click to add a new step of that type to the workflow.
 */

import React from 'react';
import { Box, Typography, List, ListItemButton, ListItemText, Chip } from '@mui/material';

const STEP_TYPES = [
  { type: 'validate', label: 'Validate', description: 'Run precondition rules', color: '#2196F3' },
  { type: 'preview', label: 'Preview', description: 'Calculate financial impact', color: '#9C27B0' },
  { type: 'approve', label: 'Approve', description: 'Pause for admin approval', color: '#FF9800' },
  { type: 'stripe_call', label: 'Stripe Call', description: 'Execute Stripe API operation', color: '#4CAF50' },
  { type: 'db_mutation', label: 'DB Mutation', description: 'Insert, update, or delete records', color: '#607D8B' },
  { type: 'audit', label: 'Audit', description: 'Create audit log entry', color: '#795548' },
  { type: 'notify', label: 'Notify', description: 'Send email or webhook', color: '#00BCD4' },
  { type: 'schedule', label: 'Schedule', description: 'Schedule future action', color: '#FF5722' },
  { type: 'condition', label: 'Condition', description: 'Branch based on rules', color: '#FFC107' },
  { type: 'bulk_iterate', label: 'Bulk Iterate', description: 'Loop over items', color: '#3F51B5' },
];

export default function StepPalette({ onAddStep }) {
  return (
    <Box sx={{ width: 200 }}>
      <Typography
        variant="overline"
        sx={{ px: 2, fontSize: '0.65rem', fontWeight: 700, letterSpacing: '0.1em', color: 'text.secondary' }}
      >
        Step Types
      </Typography>
      <List dense>
        {STEP_TYPES.map(st => (
          <ListItemButton
            key={st.type}
            onClick={() => onAddStep(st.type)}
            sx={{ borderRadius: 1, mx: 1, mb: 0.25 }}
          >
            <Box
              sx={{
                width: 8, height: 8, borderRadius: '50%', bgcolor: st.color,
                mr: 1.5, flexShrink: 0
              }}
            />
            <ListItemText
              primary={st.label}
              secondary={st.description}
              primaryTypographyProps={{ fontSize: '0.8rem', fontWeight: 500 }}
              secondaryTypographyProps={{ fontSize: '0.65rem' }}
            />
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
}

export { STEP_TYPES };
